import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { FOLDER_COUNT_FIELD_LABELS } from "%/dynamic-component-editor/standard-components/base-story-card/completion-progress-percent";

export default class FolderCountField extends BaseOption {
  static userInterfaceComponent = {
    label: "Count",
    component: inspectorTools.SIMPLE_PICKER,
    canSetOtherStates: [],
    props: {
      options: Object.entries(FOLDER_COUNT_FIELD_LABELS).map(([id, name]) => ({ name, id })),
    },
  };

  static defaultValue = "childNodes";
}
